import * as styles from "./DrawerContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";
import {
  ScrollArea,
  ScrollAreaContent,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  ScrollAreaViewport,
} from "@frontend/components/atoms/ScrollArea";

import type { DrawerContentProps } from "./Drawer.types";

export function DrawerContent({
  className,
  children,
  fade = true,
  ...props
}: DrawerContentProps): JSX.Element {
  return (
    <BaseDrawer.Content
      data-slot="drawer-content"
      className={clsx(styles.content, className)}
      {...props}
    >
      <ScrollArea className={styles.scrollArea}>
        <ScrollAreaViewport fade={fade}>
          <ScrollAreaContent className={styles.scrollContent}>
            {children}
          </ScrollAreaContent>
        </ScrollAreaViewport>

        <ScrollAreaScrollbar alwaysVisible expandOnHover>
          <ScrollAreaThumb />
        </ScrollAreaScrollbar>
      </ScrollArea>
    </BaseDrawer.Content>
  );
}
